import script from "./UserProfileDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileDetails.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileDetails.vue?vue&type=style&index=0&id=302421c4&lang=css"

const __exports__ = script;

export default __exports__